import clsx from 'clsx';
import React, { CSSProperties } from 'react';

import { Box, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ChevronLeft, ChevronRight } from '@material-ui/icons';

import StepMarker, { StepMarkerStatus } from './StepMarker';

export interface StepsNavigationProps {
  className?: string;
  currentStep?: number;
  totalSteps: number;
  onBack?: () => void;
  onNext?: () => void;
  onSubmit?: () => void;
  stepStatuses: StepMarkerStatus[];
  style?: CSSProperties;
  valid?: boolean;
}

const useStyles = makeStyles((theme) => ({
  button: {
    borderRadius: 4,
    height: 50,
    flex: 1,
    color: '#fff',

    '&:disabled': {
      backgroundColor: theme.palette.primary.main,
    },
  },
}));

const StepsNavigationMobile = (props: StepsNavigationProps) => {
  const classes = useStyles(props);

  const {
    currentStep,
    totalSteps,
    className,
    style,
    valid,
    onBack,
    stepStatuses,
    onSubmit,
    onNext,
  } = props;

  const isSubmit = currentStep === totalSteps;

  return (
    <Box component="nav" className={clsx(className)} style={style}>
      <Box
        display="flex"
        justifyContent="space-between"
        style={{ marginBottom: 50 }}
      >
        {currentStep && currentStep > 1 && (
          <Button
            disabled={currentStep === 1}
            disableElevation
            variant="contained"
            color="primary"
            className={clsx(classes.button)}
            onClick={onBack}
            startIcon={<ChevronLeft />}
            style={{ marginRight: 16 }}
          >
            Back
          </Button>
        )}
        <Button
          disabled={!valid}
          disableElevation
          variant="contained"
          color="primary"
          className={clsx(classes.button)}
          onClick={isSubmit ? onSubmit : onNext}
          endIcon={<ChevronRight />}
        >
          {isSubmit ? 'Submit' : 'Next'}
        </Button>
      </Box>
      <Box position="relative">
        <Box
          position="absolute"
          top={0}
          bottom={0}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
        >
          {stepStatuses.map((status, index) => (
            <StepMarker key={index} status={status} />
          ))}
        </Box>
        <Box display="flex" alignItems="center">
          {stepStatuses.map((status, index) => {
            if (index > 0) {
              return (
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    backgroundColor:
                      status === 'inactive' ? '#ffb781' : '#EA7217',
                    height: 2,
                    flex: 1,
                    marginRight: index + 1 === totalSteps ? 10 : 0,
                  }}
                />
              );
            }
            return null;
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default StepsNavigationMobile;
